<template>
  <div class="icons" :class="iconsAlign">
    <div v-if="flags.starts" class="icon arranca" v-b-tooltip.hover.bottomleft title="Arranca">
      <font-awesome-icon class="fa-4x" icon="key" />
      <span class="text">Arranca</span>
    </div>
    <div
      v-if="flags.walks"
      class="icon camina"
      v-b-tooltip.hover.bottomleft
      title="Arranca y camina"
    >
      <font-awesome-icon class="fa-4x" icon="road" />
      <span class="text">Arranca y camina</span>
    </div>
    <div
      v-if="flags.failure"
      class="icon falla"
      v-b-tooltip.hover.bottomleft
      title="Falla mecánica"
    >
      <font-awesome-icon class="fa-4x" :icon="['fab', 'searchengin']" />
      <span class="text">Falla mecánica</span>
    </div>
    <div
      v-if="flags.warranty"
      class="icon garantia"
      v-b-tooltip.hover.bottomleft
      title="Garantía de inspección"
    >
      <font-awesome-icon class="fa-4x" icon="medal" />
      <span class="text">Garantía</span>
    </div>
    <div v-if="flags.flooded" class="icon inundado" v-b-tooltip.hover.bottomleft title="Inundado">
      <font-awesome-icon class="fa-4x" icon="water" />
      <span class="text">Inundado</span>
    </div>
    <div v-if="flags.normalUse" class="icon uso" v-b-tooltip.hover.bottomleft title="Uso normal">
      <font-awesome-icon class="fa-4x" icon="car" />
      <span class="text">Uso normal</span>
    </div>
    <div v-if="flags.collision" class="icon colision" v-b-tooltip.hover.bottomleft title="Colisión">
      <font-awesome-icon class="fa-4x" icon="car-crash" />
      <span class="text">Colisión</span>
    </div>
    <div
      v-if="flags.spareParts"
      class="icon repuestos"
      v-b-tooltip.hover.bottomleft
      title="Repuestos"
    >
      <font-awesome-icon class="fa-4x" icon="tools" />
      <span class="text">Repuestos</span>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faKey,
  faRoad,
  faMedal,
  faWater,
  faCar,
  faCarCrash,
  faTools
} from "@fortawesome/free-solid-svg-icons";
import { faSearchengin } from "@fortawesome/free-brands-svg-icons";

library.add(
  faKey,
  faRoad,
  faSearchengin,
  faMedal,
  faWater,
  faCar,
  faCarCrash,
  faTools
);

export default {
  name: "Icons",
  props: {
    flags: {
      type: Object,
      default: function() {
        return {};
      }
    },
    align: {
      type: String,
      default: "right"
    }
  },
  computed: {
    iconsAlign: function() {
      return this.align === "left"
        ? "justify-content-start"
        : "justify-content-end";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.icons {
  font-size: 0.5rem;
  margin-top: 0.25rem;
  line-height: 2rem;
  color: $red;
  display: flex;
  flex-wrap: wrap;

  @media (min-width: viewport-min-size("lg")) and (max-width: prev-viewport-max-size("xl")) {
    font-size: 0.3rem;
    line-height: 1.3rem;
  }

  @media (min-width: viewport-min-size("md")) and (max-width: prev-viewport-max-size("lg")) {
    font-size: 0.2rem;
    line-height: 1rem;
  }

  @media (max-width: prev-viewport-max-size("xs")) {
    font-size: 0.3rem;
    line-height: 1.3rem;
  }

  .icon {
    flex-direction: column;
    align-items: center;
    margin: 0 5px 5px 0;
    display: flex;
  }

  .text {
    color: $gray;
  }
}
</style>
